export function initFilterSort() {
  const filterWrapper = document.querySelector('.po-filter');
  const filterList = document.querySelector('.po-filter__list');

  if (filterWrapper && filterList) {
    filterWrapper.addEventListener('click', () => {
      filterWrapper.classList.toggle('po-filter_active');
      filterList.classList.toggle('po-filter__list-active');
    });
  }

  const radioButtons = document.querySelectorAll('.po-radio-btn__input');
  const selectedTextElement = document.querySelector(
    '.po-filter__selected-text'
  );
  const urlParams = new URLSearchParams(window.location.search);
  const orderby = urlParams.get('orderby') || '';

  if (orderby && selectedTextElement) {
    radioButtons.forEach((rb) => {
      const label = rb.closest('label');
      const value = label.dataset.orderby;

      if (value === orderby) {
        rb.checked = true;
        selectedTextElement.textContent = label.textContent.trim();
      }
    });
  }

  radioButtons.forEach((rb) => {
    rb.addEventListener('change', () => {
      const selected = document.querySelector('input[name="aa"]:checked');
      if (!selected) return;

      const label = selected.closest('label');
      const sortVal = label.dataset.orderby;
      const labelText = label.textContent.trim();

      if (selectedTextElement) selectedTextElement.textContent = labelText;

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('orderby', sortVal);
      window.location.href = newUrl.href;
    });
  });
}
